/**
 * Created by 唐亦慧 on 2017/8/29.
 */

import {config, request, objectSerial} from 'Utils';

//组织架构列表,包含渠道
export function orgList() {
	return request(`${config.server}/api/v1/dms/organization/list`);
}

//获取组织树
export function treeList(param) {
	return request(`${config.server}/api/v1/dms/organization/tree?${objectSerial(param)}`);
}
//获取产品树
export function treeList2(param) {
	return request(`${config.server}/api/v1/dms/category/listTree?id=${param}`);
}

//修改组织
export function orgModify(param) {
	return request(`${config.server}/api/v1/dms/organization/update`,{
		method: 'post',
		body: param
	});
}


//获取子组织--传父组织id
export function childrenList(param) {
	return request(`${config.server}/api/v1/dms/organization/childList?${objectSerial(param)}`);
}


//获取详情
export function orgDetail(param) {
	return request(`${config.server}/api/v1/dms/organization/detail?${objectSerial(param)}`);
}


//添加新组织
/*
* {
 "active": 1,
 "areaIdList": [
 3,4,5,6,7
 ],
 "code": "Child1",
 "description": "新增测试-20170906",
 "name": "子组织1",
 "parentId": 7,
 "sortOrder": 1,
 "type": 0
 }
* */
export function orgAdd(param) {
	return request(`${config.server}/api/v1/dms/organization/update`,{
		method: 'post',
		body: param
	});
}


//删除组织--传id
export function orgDelete(param) {
	return request(`${config.server}/api/v1/dms/organization/delete`,{
		method: 'post',
		body: param
	});
}
export function orgAsyc() {
	return request(`${config.server}/api/v1/dms/oaMessage/org`);
}





// WEBPACK FOOTER //
// ./src/service/org/index.js